import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { carData } from "@/data/carData";

export default function SearchResults() {
  const { vin } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const cleanVin = (vin || "").trim().toUpperCase();

    if (carData[cleanVin]) {
      navigate(`/vin/${cleanVin}`, { replace: true });
    } else {
      window.location.href = `https://bid.cars/en/search/archived/results?search-type=typing&query=${cleanVin.toLowerCase()}`;
    }
  }, [vin, navigate]);

  return null;
}